import Tooltip from "components/tooltip"
import { TooltipPosition } from "components/tooltip/enums"

const statusColors = {
	ACTIVE: {
		bg: "bg-[#E4FFEC]",
		text: "text-[#068F2D]",
		circle: "bg-[#068F2D]",
		description: "Ativo",
	},
	INACTIVE: {
		bg: "bg-[#FFF5EE]",
		text: "text-[#E87725]",
		circle: "bg-[#E87725]",
		description: "Inativo",
	},
	ERROR: {
		bg: "bg-[#FEE]",
		text: "text-[#D01313]",
		circle: "bg-[#D01313]",
		description: "Erro",
	},
}

export default function FlowTag({
	status,
}: {
	status: "ACTIVE" | "INACTIVE" | "ERROR"
}) {
	return (
		<div
			className={`py-1 px-2 flex items-center justify-center  rounded w-fit gap-1  h-[24px] ${statusColors[status].bg}`}
		>
			<Tooltip
				text="O agente usado não está publicado ou foi excluído"
				position={TooltipPosition.Below}
				className=" text-center "
				disabled={status !== "ERROR"}
			>
				<div className="flex items-center justify-center gap-1">
					<div
						className={`w-2 h-2 rounded-full ${statusColors[status].circle}`}
					/>
					<p className={`text-cta-2  ${statusColors[status].text}`}>
						{statusColors[status].description}
					</p>
				</div>
			</Tooltip>
		</div>
	)
}
